import { FilterConfig } from 'components/SearchAndFilters/FilterTypes';
import SearchAndFilters from 'components/SearchAndFilters/index';
import { useSetAtom } from 'jotai';
import React, { Suspense, useCallback } from 'react';
import { Row, Col } from 'reactstrap';

import { applyFiltersAtom } from './state';

const Filters: React.FC<{ filtersConfig: FilterConfig }> = ({
  filtersConfig,
}) => {
  const applyFilters = useSetAtom(applyFiltersAtom);

  const handleFilterChange = useCallback(() => {
    applyFilters(filtersConfig.getActiveFilterValues());
  }, [applyFilters, filtersConfig]);

  return (
    <Suspense fallback={<></>}>
      <Row className="text-left align-items-center">
        <Col xs="12" md>
          <SearchAndFilters
            config={filtersConfig}
            onChange={handleFilterChange}
          />
        </Col>
      </Row>
    </Suspense>
  );
};

export default Filters;
